import { useRef, useMemo, useCallback } from 'react';
import styles from './list.module.css';
import { TextField, Button, Tooltip, Breadcrumbs, Typography } from '@mui/material';
import DataTable from 'react-data-table-component';
import { X } from 'react-feather';
import axios from 'axios';
import { TableLoader } from '../../components/LoaderC';
import Loader from '../../components/Loader';
import { authData } from "../../components/getAuth";
import withAdminAuth from "../../components/withAdminAuth";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import CancelPopup from './CancelPopup';
import { useReactToPrint } from 'react-to-print';
import { ComponentToPrintList } from './ComponentToPrintList';
import download from 'downloadjs';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';

const DataTableWithExport = ({ columns, data, customStyles, conditionalRowStyles }) => {
  const componentRef = useRef();

  const Export = ({ onExport }) => <Button onClick={e => onExport(e.target.value)} className="TableAddBU" style={{ width: 'auto' }}>Export To CSV</Button>;

  const convertArrayOfObjectsToCSV = (array) => {
    let result;

    const columnDelimiter = ',';
    const lineDelimiter = '\n';
    const keys = ['reference_id', 'container_name', 'freight', 'shipping_from', 'shipping_to', 'shipping_date', 'arrival_date', 'consignee', 'no_of_invoice', 'warehouse_location'];

    result = '';
    keys.forEach(key => {
      if (key === 'reference_id') {
        result += 'Shipping Ref';
      } else if (key === 'container_name') {
        result += 'Container No';
      } else if (key === 'freight') {
        result += 'Freight Name';
      } else if (key === 'shipping_from') {
        result += 'Shipping From';
      } else if (key === 'shipping_to') {
        result += 'Shipping To';
      } else if (key === 'shipping_date') {
        result += 'Shipping Date';
      } else if (key === 'arrival_date') {
        result += 'Arrival Date';
      } else if (key === 'consignee') {
        result += 'Consignee';
      } else if (key === 'no_of_invoice') {
        result += 'Invoice Count';
      } else if (key === 'warehouse_location') {
        result += 'Warehouse';
      } else {
        result += key;
      }
      result += columnDelimiter;
    });
    result += lineDelimiter;

    array.forEach(item => {
      let ctr = 0;
      keys.forEach(key => {
        if (ctr > 0) result += columnDelimiter;
        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }

  const downloadCSV = useCallback(() => {
    let newArray = data.map(row => {
      return { 'reference_id': row.reference_id, 'container_name': row.container_name, 'freight': row.freight, 'shipping_from': row.shipping_from, 'shipping_to': row.shipping_to, 'shipping_date': row.shipping_date ? moment(row.shipping_date).format('DD/MM/YYYY') : '-', 'arrival_date': row.arrival_date ? moment(row.arrival_date).format('DD/MM/YYYY') : '-', 'consignee': row.consignee, 'no_of_invoice': row.no_of_invoice, 'warehouse_location': row.warehouse_location }
    });

    const link = document.createElement('a');
    let csv = convertArrayOfObjectsToCSV(newArray);
    if (csv == null) return;

    const filename = 'shipping-list.csv';

    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }
    link.setAttribute('href', encodeURI(csv));
    link.setAttribute('download', filename);
    link.click();
  }, [data]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const actionsMemo = useMemo(() => <><Export onExport={() => downloadCSV()} /><Button onClick={handlePrint} className="TableAddBU" style={{ width: 'auto' }}>Print Shippings</Button></>, [downloadCSV, handlePrint]);

  return <>
    <div style={{ display: "none" }}><ComponentToPrintList ref={componentRef} data={data} /></div>
    <DataTable className='DataTable2'
      columns={columns}
      data={data}
      pagination
      customStyles={customStyles}
      conditionalRowStyles={conditionalRowStyles}
      actions={actionsMemo}
      fixedHeader={true}
      fixedHeaderScrollHeight={'633px'}
    />
  </>
}

const customDataTableStyles = {
  head: {
    style: {
      zIndex: 0
    },
  },
  headCells: {
    style: {
      backgroundColor: '#1e1e2d',
      color: '#fff'
    },
  },
}

const conditionalRowStyles = [
  {
    when: row => (row?.status === 1 || row?.status === '1'),
    style: row => ({ backgroundColor: 'rgba(42, 146, 245, 0.4)' }),
  },
  {
    when: row => (row?.status === 2 || row?.status === '2'),
    style: row => ({ backgroundColor: 'rgba(5, 156, 42, 0.5)' }),
  },
  {
    when: row => (row?.status === 3 || row?.status === '3'),
    style: row => ({ backgroundColor: 'rgba(5, 156, 42, 0.9' }),
  }
]

const ShippingList = ({ history, match }) => {
  const auth = authData();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [currentItem, setCurrentItem] = useState(0);

  const columns = [{
    name: 'Shipping Ref#',
    selector: row => row.reference_id,
    sortable: true,
  }, {
    name: 'Container No',
    selector: tableProps => (tableProps?.status === 2 || tableProps?.status === '2' || tableProps?.status === 3 || tableProps?.status === '3') ? tableProps?.container_name : (<Link className={`${styles.ActionLink}`} to={'/admin/view-shipping/' + tableProps.id}>{tableProps.container_name}</Link>),
    sortable: true,
  }, {
    name: 'Freight Name',
    selector: row => row.freight,
    sortable: true,
  }, {
    name: 'Shipping From',
    selector: row => row.shipping_from,
    sortable: true,
  }, {
    name: 'Shipping To',
    selector: row => row.shipping_to,
    sortable: true,
  }, {
    name: 'Shipping Date',
    selector: row => row.shipping_date ? moment(row.shipping_date).format('DD/MM/YYYY') : '-',
    sortable: true,
  }, {
    name: 'Arrival Date',
    selector: row => row.arrival_date ? moment(row.arrival_date).format('DD/MM/YYYY') : '-',
    sortable: true,
  }, {
    name: 'Consignee',
    selector: row => row.consignee,
    sortable: true,
  }, {
    name: 'Invoice Count',
    selector: row => row.no_of_invoice,
    sortable: true,
  }, {
    name: 'Warehouse',
    selector: row => row.warehouse_location,
    sortable: true,
  }, {
    name: 'Action',
    cell: tableProps => (
      <div className={`${styles.ActionDiv}`}>
        <Tooltip title="Download Item List As EXCEL"><Button onClick={(e) => downloadItemCSV(tableProps?.id)} style={{ width: '30px', maxWidth: '30px', minWidth: '30px', height: '30px' }}><svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.53 9L13 3.47C12.8595 3.32931 12.6688 3.25018 12.47 3.25H8C7.27065 3.25 6.57118 3.53973 6.05546 4.05546C5.53973 4.57118 5.25 5.27065 5.25 6V18C5.25 18.7293 5.53973 19.4288 6.05546 19.9445C6.57118 20.4603 7.27065 20.75 8 20.75H16C16.7293 20.75 17.4288 20.4603 17.9445 19.9445C18.4603 19.4288 18.75 18.7293 18.75 18V9.5C18.7421 9.3116 18.6636 9.13309 18.53 9ZM13.25 5.81L16.19 8.75H13.25V5.81ZM16 19.25H8C7.66848 19.25 7.35054 19.1183 7.11612 18.8839C6.8817 18.6495 6.75 18.3315 6.75 18V6C6.75 5.66848 6.8817 5.35054 7.11612 5.11612C7.35054 4.8817 7.66848 4.75 8 4.75H11.75V9.5C11.7526 9.69811 11.8324 9.88737 11.9725 10.0275C12.1126 10.1676 12.3019 10.2474 12.5 10.25H17.25V18C17.25 18.3315 17.1183 18.6495 16.8839 18.8839C16.6495 19.1183 16.3315 19.25 16 19.25Z" fill="#000000" /><path d="M14.47 11.9101C14.312 11.7893 14.1134 11.7344 13.9158 11.7568C13.7183 11.7791 13.537 11.8771 13.41 12.0301L12 13.8001L10.59 12.0001C10.5243 11.9226 10.4441 11.8588 10.3537 11.8123C10.2634 11.7659 10.1648 11.7377 10.0636 11.7293C9.96242 11.721 9.86055 11.7326 9.76384 11.7636C9.66713 11.7946 9.57747 11.8444 9.49999 11.9101C9.42251 11.9757 9.35872 12.056 9.31227 12.1463C9.26581 12.2366 9.2376 12.3352 9.22925 12.4364C9.22089 12.5376 9.23255 12.6395 9.26356 12.7362C9.29457 12.8329 9.34433 12.9226 9.40999 13.0001L11 15.0001L9.40999 17.0001C9.28534 17.1565 9.22796 17.3561 9.25046 17.5549C9.27296 17.7537 9.37351 17.9354 9.52999 18.0601C9.68647 18.1847 9.88606 18.2421 10.0848 18.2196C10.2836 18.1971 10.4653 18.0965 10.59 17.9401L12 16.2001L13.41 18.0001C13.4818 18.0871 13.5719 18.1573 13.6738 18.2057C13.7758 18.2541 13.8871 18.2795 14 18.2801C14.1534 18.2928 14.3069 18.258 14.4398 18.1804C14.5728 18.1029 14.6786 17.9863 14.743 17.8466C14.8074 17.7068 14.8273 17.5506 14.7999 17.3992C14.7726 17.2478 14.6993 17.1084 14.59 17.0001L13 15.0001L14.63 13.0001C14.6922 12.9184 14.7375 12.8252 14.7632 12.7258C14.7889 12.6264 14.7944 12.5229 14.7795 12.4214C14.7646 12.3198 14.7295 12.2223 14.6764 12.1345C14.6232 12.0466 14.5531 11.9703 14.47 11.9101Z" fill="#000000" /></svg></Button></Tooltip>
        <Tooltip title="Download Item List As PDF"><Button onClick={(e) => downloadItemPdf(tableProps?.id)} style={{ width: '20px', maxWidth: '20px', minWidth: '20px', height: '20px', marginTop: '4px' }}><svg fill="#000000" width="20px" height="20px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><path d="M1251.654 0c44.499 0 88.207 18.07 119.718 49.581l329.223 329.224c31.963 31.962 49.581 74.54 49.581 119.717V1920H169V0Zm-66.183 112.941H281.94V1807.06h1355.294V564.706H1185.47V112.94Zm112.94 23.379v315.445h315.445L1298.412 136.32Z" /><path d="M900.497 677.67c26.767 0 50.372 12.65 67.991 37.835 41.901 59.068 38.965 121.976 23.492 206.682-5.308 29.14.113 58.617 16.263 83.125 22.814 34.786 55.68 82.673 87.981 123.219 23.718 29.93 60.198 45.854 97.13 40.885 23.718-3.276 52.292-5.986 81.656-5.986 131.012 0 121.186 46.757 133.045 89.675 6.55 25.976 3.275 48.678-10.165 65.506-16.715 22.701-51.162 34.447-101.534 34.447-55.793 0-74.202-9.487-122.767-24.96-27.445-8.81-55.906-10.617-83.69-3.275-55.453 14.456-146.936 36.48-223.284 46.983-40.772 5.647-77.816 26.654-102.438 60.875-55.454 76.8-106.842 148.518-188.273 148.518-21.007 0-40.32-7.567-56.244-22.701-23.492-23.492-33.544-49.581-28.574-79.85 13.778-92.95 128.075-144.79 196.066-182.625 16.037-8.923 28.687-22.589 36.592-39.53l107.86-233.223c7.68-16.377 10.051-34.56 7.228-52.518-12.537-79.059-31.06-211.99 18.748-272.075 10.955-13.44 26.09-21.007 42.917-21.007Zm20.556 339.953c-43.257 126.607-119.718 264.282-129.996 280.32 92.273-43.37 275.916-65.28 275.916-65.28-92.386-88.998-145.92-215.04-145.92-215.04Z" /></g></svg></Button></Tooltip>
      </div>),
    sortable: false
  }];

  useEffect(() => {
    const fetchUsers = async () => {
      await axios(process.env.REACT_APP_API_URL + 'v1/shippings', {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      }).then(response => {
        setContentLoading(false);
        if (response.data.status === 'SUCCESS') {
          setAllData(response.data.data);
        }
      }).catch(error => {
        setContentLoading(false);
      });
    }

    fetchUsers();
  }, [auth?.api_token]);

  useEffect(() => {
    let filteredData = allData;

    if (filterText !== '') {
      let inputVal = filterText;
      inputVal = inputVal.toLowerCase();
      filteredData = filteredData.filter((item) => {
        return item?.reference_id.toLowerCase().includes(inputVal) || item?.container_name.toLowerCase().includes(inputVal) || item?.freight.toLowerCase().includes(inputVal) || item?.shipping_from.toLowerCase().includes(inputVal) || item?.shipping_to.toLowerCase().includes(inputVal) || item?.consignee.toLowerCase().includes(inputVal) || item?.warehouse_location.toLowerCase().includes(inputVal);
      });
    }

    setData(filteredData);
  }, [allData, filterText]);

  const convertArrayOfObjectsToCSV2 = (array) => {
    let result;

    const columnDelimiter = ',';
    const lineDelimiter = '\n';
    const keys = ['container_id', 'booking_id', 'item_id', 'title', 'amount', 'recipient_name', 'recipient_contact', 'recipient_location'];

    result = '';
    keys.forEach(key => {
      if (key === 'container_id') {
        result += 'Container Id';
      } else if (key === 'booking_id') {
        result += 'Booking Id';
      } else if (key === 'item_id') {
        result += 'Pickup Id';
      } else if (key === 'title') {
        result += 'Product';
      } else if (key === 'amount') {
        result += 'Cost';
      } else if (key === 'recipient_name') {
        result += 'Recipient Name';
      } else if (key === 'recipient_contact') {
        result += 'Recipient Contact';
      } else if (key === 'recipient_location') {
        result += 'Recipient Location';
      } else {
        result += key;
      }
      result += columnDelimiter;
    });
    result += lineDelimiter;

    array.forEach(item => {
      let ctr = 0;
      keys.forEach(key => {
        if (ctr > 0) result += columnDelimiter;
        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  }

  const downloadItemCSV = (shipId) => {
    axios.get(process.env.REACT_APP_API_URL + 'v1/shippings/booking-list/' + shipId).then(response => {
      if (response.data.status === 'SUCCESS') {
        let newArray = response.data.data;

        const link = document.createElement('a');
        let csv = convertArrayOfObjectsToCSV2(newArray);
        if (csv == null) return;

        const filename = 'shipping-item-list.csv';

        if (!csv.match(/^data:text\/csv/i)) {
          csv = `data:text/csv;charset=utf-8,${csv}`;
        }
        link.setAttribute('href', encodeURI(csv));
        link.setAttribute('download', filename);
        link.click();
      }
    });
  }

  const downloadItemPdf = (shipId) => {
    axios(process.env.REACT_APP_API_URL + 'v1/shippings-item-pdf/' + shipId, {
      responseType: 'blob'
    }).then(response => {
      const content = response.headers['content-type'];
      download(response.data, 'itemdownload.pdf', content)
    });
  }

  const cancelItem = (message, id) => {
    toast.success(message, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: "light",
    });

    setLoading(false);
    setCurrentItem(0);


    setData(prev => {
      return prev.filter(i => (i.id !== id));
    })
  }

  return (<>
    {loading && <Loader />}
    {contentLoading && <div className="LoaderCard"><div className="Loader TableLoader"><TableLoader /></div></div>}
    {!contentLoading && <div className={`${styles.MainDiv}`}>
      <div className={`${styles.PageTitleWrap}`}>
        <p className={`${styles.PageTitle}`}>View All Shipping</p>
        <Breadcrumbs aria-label="breadcrumb" className='breadcrumb'>
          <Typography color="text.primary">Shippings</Typography>
          <Typography color="text.primary">List</Typography>
        </Breadcrumbs>
      </div>

      <div className={`${styles.MainCard}`}>
        <div className='TableFilterHead'>
          <div className="DataTableSearch">
            <TextField id="search" type="text" placeholder="Search" aria-label="Search Input" value={filterText} onChange={(e) => setFilterText(e.target.value)} autoComplete='off' />
            {filterText !== '' && <Button type="button" className="CloseBU" onClick={(e) => setFilterText('')}><X /></Button>}
          </div>
        </div>
        <div>
          <div style={{ float: 'left' }}><span style={{ display: 'inline-block', width: '15px', height: '15px', background: '#FFFFFF', margin: '0 5px 0 15px', border: '#000 1px solid' }}></span><span>Container is not shipped</span></div>
          <div style={{ float: 'left' }}><span style={{ display: 'inline-block', width: '15px', height: '15px', background: 'rgba(42, 146, 245, 0.4)', margin: '0 5px 0 15px' }}></span><span>Container shipped from Warehouse</span></div>
          <div style={{ float: 'left' }}><span style={{ display: 'inline-block', width: '15px', height: '15px', background: 'rgba(5, 156, 42, 0.5)', margin: '0 5px 0 15px' }}></span><span>Container received in Ghana</span></div>
          <div style={{ float: 'left' }}><span style={{ display: 'inline-block', width: '15px', height: '15px', background: 'rgba(5, 156, 42, 0.9)', margin: '0 5px 0 15px' }}></span><span>Delivered - Ghana</span></div>
        </div>

        <div className='TableContent'>
          <DataTableWithExport className='DataTable'
            columns={columns}
            data={data}
            pagination
            customStyles={customDataTableStyles}
            conditionalRowStyles={conditionalRowStyles}
          />
        </div>
      </div>
    </div>}

    <Modal show={modalShow} onHide={(e) => { setModalShow(false); setCurrentItem(0); }} centered className='CusModal'>
      <Modal.Header closeButton>
        <Modal.Title>Cancel Shipping</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CancelPopup setModalShow={setModalShow.bind(this)} setCurrentItem={setCurrentItem.bind(this)} camcelItem={cancelItem.bind(this)} shippingId={currentItem} />
      </Modal.Body>
    </Modal>
  </>)
}

export default withAdminAuth(ShippingList);